import { cn } from "@/lib/utils"

/**
 * Contenedor de CONTENIDO: centra y limita el ancho en pantallas grandes.
 *
 * Patrón "full-bleed background + constrained content":
 * - El FONDO (color, imagen, borde) va en el elemento PADRE, que ocupa todo el
 *   ancho de la pantalla (`w-full`).
 * - Este componente NO pinta fondo: solo restringe el contenido a `max-w-6xl`
 *   (1152px), lo centra (`mx-auto`) y aplica el padding horizontal responsivo.
 *
 * Así el color/imagen abarca toda la pantalla mientras el texto y los controles
 * se mantienen legibles y centrados en monitores XL/4K.
 *
 * @example
 * <section className="bg-muted">          // fondo a todo el ancho
 *   <Container className="py-16">…</Container>  // contenido limitado y centrado
 * </section>
 */
export function Container({ className, ...props }: React.ComponentProps<"div">) {
	return <div className={cn("mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8", className)} {...props} />
}
